import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';
import { b as bem } from './p-g1JgJ7wn.js';
import { d as defineCustomElement$1 } from './p-BMLmP8GU.js';

const cosmosSelectValueCss = ":host{height:100%;max-width:100%;position:relative}:host([multiple]){display:inline}.cosmos-select-value{--cosmos-text-color:currentColor;align-items:center;border-radius:4px;box-sizing:border-box;cursor:default;display:inline-flex;margin:0;max-width:100%;position:relative;-webkit-user-select:none;user-select:none;width:100%}.cosmos-select-value--multiple{display:inline}.cosmos-select-value--multiple ::slotted([slot=prefix]){display:inline-block;margin-bottom:2px;vertical-align:middle}.cosmos-select-value__label{flex-grow:1;overflow:hidden}.cosmos-select-value--multiple .cosmos-select-value__label{display:inline}.cosmos-select-value ::slotted([slot=prefix]){flex:0 0 auto;margin-inline-end:var(--cosmos-select-gap, 6px);--cosmos-icon-size:18px;--cosmos-flag-width:18px;--cosmos-avatar-size:18px}";

const generateClassNames = bem('cosmos-select-value');
const CosmosSelectValue = /*@__PURE__*/ proxyCustomElement(class CosmosSelectValue extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * Accommodates multiple select values.
         */
        this.multiple = false;
        this.meta = '';
        this.title = '';
        /**
         * Updates title and meta values when slot content changes.
         * Extracts text content and meta attribute from slotted elements.
         */
        this.handleSlotChange = (event) => {
            var _a, _b;
            const slot = event.target;
            const nodes = slot === null || slot === void 0 ? void 0 : slot.assignedNodes();
            if (!(nodes === null || nodes === void 0 ? void 0 : nodes.length)) {
                return;
            }
            const parentElement = (_a = nodes[0]) === null || _a === void 0 ? void 0 : _a.parentElement;
            if (!parentElement) {
                return;
            }
            const newTitle = ((_b = parentElement.textContent) === null || _b === void 0 ? void 0 : _b.trim()) || '';
            const newMeta = parentElement.getAttribute('meta') || '';
            // Only update state when values change to prevent unnecessary renders
            if (this.title !== newTitle) {
                this.title = newTitle;
            }
            if (this.meta !== newMeta) {
                this.meta = newMeta;
            }
        };
    }
    /**
     * Returns the full title for tooltip display.
     * Shows complete selected value(s) on hover when content is truncated.
     */
    getTitle() {
        return this.meta ? `${this.title} • ${this.meta}` : this.title;
    }
    render() {
        return (h(Host, { key: '3886bf7a476a06bd2f7ced34e4a1964ef06f19f2' }, h("div", { key: '5bfe74ac92d7e3f8e741c202cc098f1a6823a32f', title: this.getTitle(), class: generateClassNames({ multiple: this.multiple }), part: "base" }, h("slot", { key: '959f1ff58e9e65fa1966a8f0ddb636469472f930', "aria-hidden": "true", name: "prefix" }), h("cosmos-text", { key: 'a1ff0cb297d9d4a2b84d49157eabb4de2f3cc808', clamp: 1, class: generateClassNames('label'), exportparts: "base: label", size: "small", tag: this.multiple ? 'span' : 'p' }, h("span", { key: 'a98e4471092d0e7548606717f2849cb37d4d4341' }, h("slot", { key: '05890a708011dcde3490272da4ac1dc3a643e4db', onSlotchange: this.handleSlotChange }))))));
    }
    get element() { return this; }
    static get style() { return cosmosSelectValueCss; }
}, [1, "cosmos-select-value", {
        "multiple": [516],
        "meta": [32],
        "title": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-select-value", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-select-value":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosSelectValue);
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}

export { CosmosSelectValue as C, defineCustomElement as d };
